export const GET_DOCUMENTS = "GET_DOCUMENTS";
export const GET_ID_DOCUMENTS = "GET_ID_DOCUMENTS";
export const GET_MD5_DOCUMENTS = "GET_MD5_DOCUMENTS";
export const POST_DOCUMENTS = "POST_DOCUMENTS";
export const LOADING_DOCUMENTS = "LOADING_DOCUMENTS";
export const ERROR_DOCUMENTS = "ERROR_DOCUMENTS";
